<template>
  <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5,7A6.764,6.764,0,0,0,8.5.5,6.764,6.764,0,0,0,1.5,7a6.764,6.764,0,0,0,7,6.5,7.554,7.554,0,0,0,1.43-.137L13.5,15.5v-4A6.57,6.57,0,0,0,15.5,7Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line stroke-linecap="round" stroke-linejoin="round" x1="8.5" x2="8.5" y1="3.5" y2="7.5" />
    <path class="v-icon-fill-color" d="M8.5,9a1,1,0,1,0,1,1A1,1,0,0,0,8.5,9Z" />
  </svg>
</template>
